module.exports = __webpack_public_path__ + "static/media/Configuración_UMA.fb26fab0.svg";